import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"
import { EPlanCouponDiscountType } from "../../Enum/EPlanCouponDiscountType"
import { AdminPlanCoupon } from "./AdminPlanCoupon"

export class AdminSavePlanCoupon {
  code: string

  discountType: EPlanCouponDiscountType

  discountValue: number

  validFromUtc?: string

  validUntilUtc?: string

  maxUsageTotal?: number

  maxUsagePerCompany?: number

  restrictToPlanEntityId?: number

  restrictToPeriodType?: EBillingPeriodType

  restrictToCompanyEntityId?: number

  linkedResellerEntityId?: number

  isActive: boolean

  constructor(data: Partial<AdminSavePlanCoupon> | AdminPlanCoupon = {}) {
    this.code = data.code ?? ""

    this.discountType = data.discountType ?? EPlanCouponDiscountType.Percentage

    this.discountValue = data.discountValue ?? 0

    this.validFromUtc = data.validFromUtc

    this.validUntilUtc = data.validUntilUtc

    this.maxUsageTotal = data.maxUsageTotal

    this.maxUsagePerCompany = data.maxUsagePerCompany

    this.restrictToPlanEntityId = data.restrictToPlanEntityId

    this.restrictToPeriodType = data.restrictToPeriodType

    this.restrictToCompanyEntityId = data.restrictToCompanyEntityId

    this.linkedResellerEntityId = data.linkedResellerEntityId

    this.isActive = data.isActive ?? true
  }
}
